/*
 * Swatch hover-preview for Booster product cards.
 * On mouseenter of a color swatch, swaps the product-card image to the
 * matching variant's featured_media. On mouseleave of the swatch group,
 * reverts to the originally-displayed media.
 *
 * Relies on Booster's pre-rendered variant media: each variant's image is
 * already present in the card as a .product__media-item with a unique
 * data-media-id. We simply prepend the matching one to .card__media, which
 * is the same technique Booster uses on variant click (global.js:updateMedia).
 */
(function () {
  var SWATCH_SEL = '.wbswatchclr .color-swatch, .wbswatchclr .color-swatchimg';
  var CONTAINER_SEL = '.wbswatchclr';
  var CARD_SEL = '.card-wrapper, .card';

  function getVariants(card) {
    var radios = card.querySelector('variant-radios, variant-selects');
    if (!radios) return null;
    var script = radios.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return { variants: JSON.parse(script.textContent), section: radios.dataset.section, product: radios.dataset.product };
    } catch (e) {
      return null;
    }
  }

  function findVariantByValue(variants, value) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === value || v.option2 === value || v.option3 === value) return v;
    }
    return null;
  }

  function handleEnter(e) {
    var swatch = e.currentTarget;
    var value = swatch.getAttribute('data-val');
    if (!value) return;
    var card = swatch.closest(CARD_SEL);
    if (!card) return;
    var data = getVariants(card);
    if (!data) return;
    var variant = findVariantByValue(data.variants, value);
    if (!variant || !variant.featured_media) return;
    var mediaId = data.section + '-' + data.product + '-' + variant.featured_media.id;
    var mediaEl = card.querySelector('[data-media-id="' + mediaId + '"]');
    if (!mediaEl) return;
    var mediaContainer = card.querySelector('.card__media');
    if (!mediaContainer) return;
    if (!card.__bmsHoverActive) {
      var firstMedia = mediaContainer.querySelector('.product__media-item');
      if (firstMedia) card.__bmsHoverOriginal = firstMedia.getAttribute('data-media-id');
      card.__bmsHoverActive = true;
    }
    if (mediaContainer.firstElementChild === mediaEl) return;
    mediaContainer.prepend(mediaEl);
  }

  function handleContainerLeave(e) {
    var container = e.currentTarget;
    var card = container.closest(CARD_SEL);
    if (!card || !card.__bmsHoverActive) return;
    var mediaContainer = card.querySelector('.card__media');
    var originalId = card.__bmsHoverOriginal;
    if (mediaContainer && originalId) {
      var originalEl = card.querySelector('[data-media-id="' + originalId + '"]');
      if (originalEl && mediaContainer.firstElementChild !== originalEl) {
        mediaContainer.prepend(originalEl);
      }
    }
    card.__bmsHoverActive = false;
    card.__bmsHoverOriginal = null;
  }

  function attachSwatch(sw) {
    if (sw.__bmsHoverBound) return;
    sw.__bmsHoverBound = true;
    sw.addEventListener('mouseenter', handleEnter);
  }

  function attachContainer(c) {
    if (c.__bmsLeaveBound) return;
    c.__bmsLeaveBound = true;
    c.addEventListener('mouseleave', handleContainerLeave);
  }

  function initAll(root) {
    (root || document).querySelectorAll(SWATCH_SEL).forEach(attachSwatch);
    (root || document).querySelectorAll(CONTAINER_SEL).forEach(attachContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when new cards appear (e.g., AJAX filter updates, product grid re-renders)
  try {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SWATCH_SEL)) attachSwatch(node);
          if (node.matches && node.matches(CONTAINER_SEL)) attachContainer(node);
          if (node.querySelectorAll) initAll(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (e) {
    /* ignore */
  }
})();
